<span class="dot"></span>
<span class="dot" [class.dot--muted]="proficiencyLevel < 2"></span>
<span class="dot" [class.dot--muted]="proficiencyLevel < 3"></span>
<span class="dot" [class.dot--muted]="proficiencyLevel < 4"></span>
